// store/modules/firstPickup/action.js
import util from '../../../util';
import RangeBoxGeneralApi from '../../../api/modules/RangeBoxGeneralApi';

const listRangeBox = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/rangeBox/${payload.idOrder}`, {headers}).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los detalles.')
      reject(error)
    })
  })
}

const updateBoxFull = ({ commit }, { context, idOrderGeneral, code, full }) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();
    context.axios.put(`/boxDetails/${idOrderGeneral}/${code}/full?full=${full}`, null, { headers })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        util.showDialogError(context, 'Error al actualizar estado');
        reject(error);
      });
  });
};

/**
 * Lista cajas pendientes por cliente (obligatorio) y orden (opcional)
 */
const listPendingRangeBox = ({ commit }, { context, idClient, idOrder }) => {
  return RangeBoxGeneralApi.listPendingRangeBox(context, idClient, idOrder);
};

export default {
  listRangeBox,
  updateBoxFull,
  listPendingRangeBox
}



// WEBPACK FOOTER //
// ./src/store/modules/rangeBoxGeneral/actions.js